
import MarkdownEditor from "@/Components/Forms/MarkdownEditor.vue";
import HcButton from "@/Components/Buttons/Button.vue";
// @ts-ignore
import PeoplePicker from "@/Components/Controls/PeoplePicker.vue";
import { defineComponent, PropType } from "vue";
import Card from "@/Components/General/Card.vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiLoading } from "@mdi/js";
// @ts-ignore
import RfpCategorySelect from "@/Components/Rfp/RfpCategorySelect.vue";
// @ts-ignore
import RfpMeasures from "@/Components/Rfp/RfpMeasures.vue";
// @ts-ignore
import RfpCategory from "@/types/Rfp/RfpCategory";
import AppLayout from "@/Layouts/AppLayout.vue";
import route from "ziggy-js";
import User from "@/types/User";
import { useForm } from "@inertiajs/inertia-vue3";
import Label from "@/Pages/Product/Label.vue";

export default defineComponent({
  components: {

    Card,
    SvgIcon,
    HcButton,
    PeoplePicker,
    MarkdownEditor,
    RfpCategorySelect,
    RfpMeasures,
},
  props: {
    users: {
      type: [Array, Object] as PropType<
        User[]
      >,
      required: true,
    },
    categories: {
      type: Object as PropType<RfpCategory[]>,
      required: true,
    }
  },
  setup() {
    const form = useForm({
      title: "",
      occured_at: null,
      deadline: null,
      description: "",
      measures: "",
      participant_ids: [] as number[],
      assigned_ids: [] as any[],
      category_ids: [] as number[],
    });

    const send = () => {
      form.post(route("rfp.store"));
    };

    return {
      form,
      send,
      loadingIcon: mdiLoading,
    };
  },
  layout: AppLayout,
});
